module.exports = __webpack_public_path__ + "static/media/move_camera_on.cc000247.svg";